import { IChartFilter, IChartFilterSectionItem } from '../contexts/DashboardContext';
import { CategoriesItem } from '../types/categoriesItem';

export const mapOptionsForPeriodTypes = (chartFilter?: IChartFilter) => {
  const { sections } = chartFilter || {};
  const mappedOptionsByPeriodType = {};
  sections?.forEach((periodType) => {
    // @ts-ignore
    mappedOptionsByPeriodType[periodType.title] = periodType?.items.flatMap(item => item.shortTitle);
  });
  return mappedOptionsByPeriodType;
};

export const getStartTimeForPeriodType = (chartFilters: IChartFilter, periodType: string, subPeriodType: string) => {
  let startTime = null;
  const { sections } = chartFilters || {};
  sections?.forEach((section: IChartFilterSectionItem) => {
    if (section.title === periodType) {
      section.items?.forEach((item) => {
        if (item.shortTitle === subPeriodType) startTime = item.startDate;
      });
    }
  });
  return startTime;
};

export const calculatePercentages = (data: CategoriesItem[]) => {
  if (!data.length) return [];

  const total = data.reduce((sum, item) => sum + item.total, 0);

  return data.map(item => ({
    ...item,
    percentage: ((item.total / total) * 100).toFixed(2),
  }));
};

export const getColorSet = (categoriesItems: CategoriesItem[]) => [
  // Replace first color to `bw-04` if there are no categories (empty state)
  categoriesItems ? '#0245A2' : '#C4CBDC', // action05 | bw-04
  '#0E5CF4', // blue03
  '#94D9EF', // action02New
  '#DBF0F7', // action01New
  '#C5D1FF',
];

export const getColoredCategories = (categoriesItems: CategoriesItem[]) => {
  if (!categoriesItems) return [];
  return categoriesItems.map((item, index) => ({
    ...item,
    color: getColorSet(categoriesItems)[index],
  }));
};
